// How many fetchGateways requests are running. Requests overlap (several
// callers start them independently), so a count, not a flag, keeps the
// transaction tabs locked until the last one ends (see areTransactionTabsLocked).
const gatewaysRequestsInFlight = (state, action) => {
  if (state === undefined) {
    return 0;
  }
  switch (action.type) {
    case 'GATEWAYS_REQUEST_STARTED':
      return (state.gatewaysRequestsInFlight ?? 0) + 1;
    case 'GATEWAYS_REQUEST_ENDED':
      return Math.max(0, (state.gatewaysRequestsInFlight ?? 0) - 1);
    default:
      return state.gatewaysRequestsInFlight;
  }
};

export { gatewaysRequestsInFlight };
